import { apiUrl, authHeaders, authJsonHeaders } from "./httpAuth";

export async function createReparacion(payload) {
    const res = await fetch(apiUrl("api/reparaciones/create"), {
        method: "POST",
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json().catch(() => null);
}

export async function updateReparacion(reparacionId, payload) {
    const res = await fetch(apiUrl(`api/reparaciones/update/${reparacionId}`), {
        method: "PUT",
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json().catch(() => null);
}

export async function deleteReparacion(reparacionId) {
    const res = await fetch(apiUrl(`api/reparaciones/delete/${reparacionId}`), {
        method: "DELETE",
        headers: authHeaders(),
    });
    return res;
}
